import { createFileRoute } from '@tanstack/react-router'
import { HomePage } from '../components/home-page'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/')({
  loader: () => loadPageData({ data: { kind: 'home', locale: 'fr' } }),
  head: () => staticRouteHead('home', 'fr'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <HomePage />
    </CatalogProvider>
  )
}
